import i18n from 'i18next';
import { sweetAlert } from './sweetAlert';

// The back-office preview tells the form, in each message, whether it shows a simulation: a
// screen the form may not be in (« Formulaire ouvert », the update of a participant…). Nothing
// done in a simulation is recorded: no response, no workshop, no ticketing session, no SMS.

/**
 * The form in the preview of the form editor: in its frame, at the address only that preview builds
 * (`preview=1`). The reception desk, a site that frames the form or the form opened alone record
 */
export function isBackOfficePreview(search: string, isFramed: boolean): boolean {
  return isFramed && new URLSearchParams(search).get('preview') === '1';
}

// In the preview, a simulation until the back-office says which screen it shows: nothing sent in
// the instant before its first message is recorded
let simulation = isBackOfficePreview(window.location.search, window.parent !== window);

/**
 * The flag a preview message carries. A form without it comes from an older back-office, whose
 * preview records, as it always did; a message without a form (the tab shown) keeps the flag
 */
export function simulationOfMessage(data: { simulation?: unknown; fields?: unknown }, current: boolean): boolean {
  if ('simulation' in data) return data.simulation === true;
  return data.fields ? false : current;
}

export function setPreviewSimulation(value: boolean): void {
  simulation = value;
}

export function isPreviewSimulation(): boolean {
  return simulation;
}

type SubmitStep = { partialUpdate: boolean; isLastTab?: boolean; showSummary: boolean };

/**
 * What a sending does in a simulation, instead of recording: a tab saved one by one moves on, the
 * last one leads to the summary when the form has one (as the real sending does), and the sending of
 * the form says that nothing was recorded
 */
export function simulatedSubmitOutcome({ partialUpdate, isLastTab, showSummary }: SubmitStep): 'next-step' | 'summary' | 'alert' {
  if (!partialUpdate) return 'alert';
  return isLastTab && showSummary ? 'summary' : 'next-step';
}

/** Says, where the form would have recorded something, that the simulation did not */
export function alertPreviewSimulation(options: Record<string, unknown> = {}) {
  return sweetAlert({
    icon: 'info',
    title: i18n.t('preview-simulation.title'),
    text: i18n.t('preview-simulation.text'),
    ...options,
  });
}
